import React from 'react'
import { connect } from 'react-redux'
import { isNil } from 'lodash'
import { Navigate as Redirect } from 'react-router'
import PropTypes from 'prop-types'
import Component from '../common/Component'
import SharedBusinessRuleForm from './SharedBusinessRuleForm'
import createFlashMessage from '../../actions/FlashMessages/createFlashMessage'
import actions from '../../actions/SharedBusinessRules'
import validationActions from '../../actions/SharedBusinessRulesValidation'

export class SharedBusinessRuleNew extends Component {
  static propTypes = {
    create: PropTypes.func,
    reset: PropTypes.func,
    createValidation: PropTypes.func,
    resetValidation: PropTypes.func,
    created: PropTypes.bool.isRequired,
    createFlashMessage: PropTypes.func.isRequired,
    requestInProgress: PropTypes.bool,
    resourceErrors: PropTypes.object,
    resourceErroredFields: PropTypes.array,
    initialValues: PropTypes.object,
    configuration: PropTypes.object
  }

  static defaultProps = {
    resourceErrors: [],
    initialValues: {
      shared_business_rule_type: '',
      payload: null,
      effective_date: '',
      expiration_date: '',
      matching_type: '',
      matching_data: null
    }
  }

  componentWillUnmount() {
    this.props.reset()
    this.props.resetValidation()
  }

  handleSubmit = async (values) => {
    const response = await this.props.create(values)

    if (isNil(response.resourceErrors)) {
      this.props.createFlashMessage('Created Business Rule', { tag: 'general' })
    }
  }

  render() {
    if (this.props.created) return (<Redirect replace to="/business_rules" />)

    return (
      <div className="content">
        <h2>New Business Rule</h2>
        <div>
          <SharedBusinessRuleForm
            businessRuleTypes={this.props.configuration.business_rule_types}
            matchingTypes={this.props.configuration.matching_types}
            resourceErrors={this.props.resourceErrors}
            resourceErroredFields={this.props.resourceErroredFields}
            requestInProgress={this.props.requestInProgress}
            createValidation={this.props.createValidation}
            initialValues={this.props.initialValues}
            handleSubmit={this.handleSubmit}
            submitLabel="Create Business Rule"
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const configuration = state.login.session.configuration.shared_business_rules
  const businessRuleResource = state.sharedBusinessRules.create
  const resourceErrors = businessRuleResource.resourceErrors || {}

  return {
    requestInProgress: businessRuleResource.requestInProgress,
    created: businessRuleResource.created,
    resourceErroredFields: Object.keys(resourceErrors),
    resourceErrors,
    configuration
  }
}

const mapDispatchToProps = {
  createValidation: validationActions.create.main,
  resetValidation: validationActions.create.reset,
  create: actions.create.main,
  reset: actions.create.reset,
  createFlashMessage
}
export default connect(mapStateToProps, mapDispatchToProps)(SharedBusinessRuleNew)
